import { render, staticRenderFns } from "./DataItemDiffContainer.vue?vue&type=template&id=5aeb2f51&scoped=true&"
import script from "./DataItemDiffContainer.vue?vue&type=script&lang=ts&"
export * from "./DataItemDiffContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DataItemDiffContainer.vue?vue&type=style&index=0&id=5aeb2f51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb2f51",
  null
  
)

export default component.exports